import ArtistRiderDetailApp from "ArtistRider/detail/app";
import ArtistRiderList from "ArtistRider/List/App";
import ArtistRiderNewApp from "ArtistRider/new/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const artistRiderRoute: RouteObject = {
  path: "artistrider",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ArtistRiderList,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: ArtistRiderNewApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: ArtistRiderDetailApp,
  }]
};